// extracted by mini-css-extract-plugin
module.exports = {"itemPanel":"antd-pro-pages-editor-flow-components-editor-item-panel-index-itemPanel"};